<template>
  <div
    class="hero is-fullheight fullpage-section"
    data-anchor="section-qeuf"
    :style="fondo"
  >
    <div class="column qeuf-content ">
      <div class="columns is-half-desktop" align="right">
        <div class="column is-1-desktop is-hidden-mobile"></div>
        <div class="column is-hidden-desktop" align="center">
          <div class="column is-hidden-mobile"></div>
          <h1 class="is-size-4 white-color has-font-unica">
            <p class="is-size-5">¿quÉ ES UNA <br /></p>
            FUNDA<br />
            COSMÉTICA?
          </h1>
        </div>
        <div
          class="column is-5-desktop is-8-touch black-background white-color"
          align="center"
        >
          <div class="column is-9-desktop black-background is-size-4 is-size-6-touch">
            <div class="column is-hidden-mobile height10"></div>
            Una funda cosmética es una <br class="is-hidden-mobile" />
            órtesis que se dispone sobre la <br class="is-hidden-mobile" />
            prótesis del paciente. <br /><br class="is-hidden-mobile" />

            CALCE produce fundas cosmeticas <br class="is-hidden-mobile" />
            <strong class="white-color">transfemorales</strong> y
            <br class="is-hidden-mobile" />
            <strong class="white-color">transtibiales.</strong> <br /><br />

            Poseemos un desarrollo constante <br class="is-hidden-mobile" />
            para que nuestro producto posea <br class="is-hidden-mobile" />
            cualidades acordes a los <br class="is-hidden-mobile" />
            requerimientos que posea.<br /><br />
            <a href="https://www.calce.cl/catalogo_2020">
              <button class="button button-style is-transparent">
                Catálogo
              </button>
            </a>
          </div>
        </div>
        <div class="column is-half-desktop is-hidden-mobile" align="center">
          <div class="column height20"></div>
          <h1 class="is-size-1 white-color has-font-unica">
            <p class="is-size-3">¿qué ES</p>
            UNA <br />
            FUNDA<br />
            COSMÉTICA?
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from '@/utils/assets-helpers'

export default {
  methods: {
    getImg
  },
  data: function() {
    return {
      fondo: `background-image: url("${getImg(
        'QueEsunaFunda/fondo-QEUF.jpg'
      )}"); background-size: cover`
    }
  }
}
</script>

<style>
.black-background {
  background: rgba(0, 0, 0, 0.8);
}

.qeuf-content {
  height: 100vh;
}

.height20 {
  height: 20vh;
}

.height10 {
  height: 10vh;
}

.button-style {
  background-color: transparent;
  color: white;
  border-color: white;
  border-width: thick;
}
</style>
